// ============================================================
// DENTRO IL CALICE — AI WINERY
// Tutti i contenuti editoriali del sito, separati dai componenti
// per una modifica semplice e centralizzata.
// ============================================================

export const IMAGES = {
  heroVineyard:
    "https://images.unsplash.com/photo-1596142332133-327e2a0ff006?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  barrelCellar:
    "https://images.unsplash.com/photo-1771003601879-6b9c0f26a1d5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  vineyardVilla:
    "https://images.unsplash.com/photo-1782070308261-15cb7a4720ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  tastingRoom:
    "https://images.unsplash.com/photo-1733754513944-e7528024af2e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  businessMeeting:
    "https://images.unsplash.com/photo-1578574577315-3fbeb0cecdc2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  vineyardHillside:
    "https://images.unsplash.com/photo-1667743537770-2b4691bfe7a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const BRAND = {
  name: "DENTRO IL CALICE",
  division: "AI WINERY",
  descriptor: "Revenue & Operations for Wineries",
  tagline: "Outcome davanti. AI dietro.",
};

export const NAV = [
  { label: "Soluzioni", href: "#soluzioni" },
  { label: "Metodo", href: "#metodo" },
  { label: "Servizi", href: "#servizi" },
  { label: "ROI", href: "#roi" },
  { label: "Perché noi", href: "#perche-noi" },
  { label: "FAQ", href: "#faq" },
];

export const HERO = {
  eyebrow: "Outcome davanti. AI dietro.",
  headlinePre: "La tua cantina,",
  headlineLines: ["più trovabile.", "più prenotabile.", "più ricomprabile."],
  body:
    "Dentro il Calice AI Winery integra intelligenza artificiale, automazioni e dati nei processi commerciali delle aziende vitivinicole. Non sostituiamo le persone: eliminiamo attività ripetitive, informazioni disperse e opportunità commerciali dimenticate.",
  ctaPrimary: "Richiedi una diagnosi gratuita",
  ctaSecondary: "Vedi le applicazioni",
  microcopy:
    "20–30 minuti. Nessun impegno. Nessun report automatico. Analizziamo insieme dove la tua cantina perde tempo, dati o opportunità commerciali.",
};

export const MARQUEE = [
  "Outcome davanti. AI dietro.",
  "Prima misuriamo. Poi automatizziamo.",
  "Un caso d'uso. Un KPI. Un risultato misurabile.",
  "L'AI ha valore solo se cambia un numero.",
  "Non aggiungiamo software. Mettiamo ordine nei processi.",
];

export const PROBLEMS = {
  eyebrow: "Il problema",
  title: "La cantina ha già i dati.\nSpesso non li sta usando.",
  cards: [
    {
      k: "01",
      title: "Lead persi",
      body: "Richieste, fiere e contatti commerciali senza follow-up sistematico.",
    },
    {
      k: "02",
      title: "Database dispersi",
      body: "CRM, Excel, email, ecommerce e contatti non comunicano tra loro.",
    },
    {
      k: "03",
      title: "Clienti che non ricomprano",
      body: "La degustazione termina, ma spesso termina anche la relazione.",
    },
    {
      k: "04",
      title: "Export lento",
      body: "Ore dedicate a ricerca, qualificazione e gestione di potenziali buyer.",
    },
    {
      k: "05",
      title: "Processi manuali",
      body: "Report, documenti, contenuti e attività ripetitive sottraggono tempo.",
    },
    {
      k: "06",
      title: "AI senza metodo",
      body: "Strumenti utilizzati individualmente senza policy, controllo o processo condiviso.",
    },
  ],
};

export const OUTCOMES = {
  eyebrow: "Cosa cambia",
  title: "Non partiamo dall'AI.\nPartiamo dal risultato.",
  modules: [
    {
      num: "01",
      title: "Essere trovata",
      body: "Comparire meglio nelle ricerche tradizionali e nelle nuove ricerche generative.",
      output: "GEO, contenuti strutturati, knowledge architecture.",
    },
    {
      num: "02",
      title: "Essere prenotata",
      body: "Ridurre richieste perse, tempi di risposta e abbandono prima della visita.",
      output: "Assistente, booking workflow, follow-up.",
    },
    {
      num: "03",
      title: "Essere ricomprata",
      body: "Trasformare visitatori e degustazioni in relazioni continuative.",
      output: "CRM, segmentazione, reactivation e customer journey.",
    },
    {
      num: "04",
      title: "Vendere meglio in fiera",
      body: "Preparare, qualificare e seguire buyer e contatti senza fogli dispersi.",
      output: "Lead workflow, scoring, pipeline e follow-up.",
    },
    {
      num: "05",
      title: "Risparmiare tempo",
      body: "Automatizzare attività documentali e ripetitive mantenendo controllo umano.",
      output: "Knowledge assistant e workflow.",
    },
    {
      num: "06",
      title: "Usare l'AI con controllo",
      body: "Definire procedure, formazione, responsabilità e governance.",
      output: "AI literacy, policy operative e human review.",
    },
  ],
};

export const METHOD = {
  eyebrow: "Metodo",
  title: "Prima misuriamo.\nPoi automatizziamo.",
  steps: [
    { num: "01", title: "Diagnosi", body: "Analizziamo processi, dati, strumenti e obiettivi." },
    { num: "02", title: "Priorità", body: "Identifichiamo i casi d'uso con il miglior rapporto impatto/fattibilità." },
    { num: "03", title: "Implementazione", body: "Configuriamo workflow, automazioni e integrazioni." },
    { num: "04", title: "Formazione", body: "Il team impara a utilizzare e controllare il sistema." },
    { num: "05", title: "Misurazione", body: "Confrontiamo KPI prima/dopo e decidiamo cosa ottimizzare." },
  ],
  highlight: "Un caso d'uso. Un KPI. Un risultato misurabile.",
};

export const SERVICES = {
  eyebrow: "Servizi",
  title: "Un percorso, non un catalogo di software.",
  packages: [
    {
      name: "AI Wine Audit",
      price: "€1.250",
      priceNote: "una tantum",
      duration: "7–10 giorni lavorativi",
      description: "Il punto di partenza. Fotografiamo processi, dati e opportunità della tua cantina.",
      features: [
        "2 workshop",
        "Mappatura processi",
        "Analisi data readiness",
        "8–12 possibili casi d'uso",
        "Matrice impatto/fattibilità",
        "Analisi dei rischi",
        "Roadmap 90 giorni",
        "Stima economica del progetto",
      ],
      output: "Report decisionale + backlog prioritizzato + architettura proposta.",
      cta: "Inizia dall'audit",
      route: "/ai-wine-audit",
      featured: true,
    },
    {
      name: "AI Revenue Starter",
      price: "€4.900",
      priceNote: "setup + €390/mese",
      description: "Per cantine che vogliono migliorare CRM e follow-up senza avviare un progetto enterprise.",
      features: [
        "Data hygiene di base",
        "3 workflow",
        "Lead capture",
        "Lead qualification",
        "Follow-up",
        "Reactivation clienti",
        "Assistente interno",
        "Dashboard KPI",
        "Formazione",
      ],
      cta: "Scopri Revenue Starter",
      route: "/revenue-starter",
      featured: false,
    },
    {
      name: "AI Growth System",
      price: "€8.900",
      priceNote: "setup + €790/mese",
      description: "Per cantine con team commerciale, marketing, DTC o più canali.",
      features: [
        "6–8 workflow",
        "Sales copilot",
        "Knowledge base",
        "Segmentazione",
        "Reactivation",
        "Content operations",
        "Reporting",
        "Integrazioni standard",
        "Formazione, monitoraggio, ottimizzazione continua",
      ],
      cta: "Scopri Growth System",
      route: "/growth-system",
      featured: false,
    },
    {
      name: "AI Export & Scale",
      price: "€14.900",
      priceNote: "setup + €1.490/mese",
      description: "Per aziende strutturate con export attivo o obiettivi di internazionalizzazione.",
      features: [
        "8–10+ workflow",
        "Market research assistito",
        "Account scoring",
        "Pipeline export",
        "Materiali multilingua",
        "Follow-up + knowledge base",
        "Dashboard + governance",
        "Integrazioni + quality control",
        "Review mensile",
      ],
      output: "Il servizio aumenta capacità, velocità e disciplina del processo commerciale. Non promettiamo ordini, distributori o incremento export garantito.",
      cta: "Parliamo del tuo export",
      route: "/export-scale",
      featured: false,
    },
  ],
  enterprise: {
    name: "Soluzioni Enterprise",
    price: "Da €25.000 setup + €2.500/mese",
    description: "Per ERP integration, SSO, business unit multiple, ambienti dedicati, security avanzata e integrazioni custom.",
    cta: "Richiedi assessment",
  },
};

export const IMPACT = {
  eyebrow: "ROI / Business impact",
  title: "L'AI ha valore solo se cambia un numero.",
  disclaimerTop: "I KPI vengono definiti prima dell'implementazione. Non promettiamo percentuali di miglioramento standard.",
  kpis: [
    { label: "Tempo medio di risposta", dir: "down" },
    { label: "Lead → Meeting", dir: "up" },
    { label: "Prenotazioni", dir: "up" },
    { label: "Tasso di riacquisto", dir: "up" },
    { label: "Clienti riattivati", dir: "up" },
    { label: "Ore di lavoro manuale", dir: "down" },
    { label: "Completezza CRM", dir: "up" },
    { label: "Follow-up eseguiti", dir: "up" },
  ],
};

export const CALCULATOR = {
  eyebrow: "ROI Calculator",
  title: "Quanto costano oggi i processi manuali alla tua cantina?",
  disclaimer:
    "Questa simulazione non costituisce una previsione di fatturato o una garanzia di ROI. Serve esclusivamente a quantificare l'ordine di grandezza dell'inefficienza analizzata.",
  cta: "Analizziamo i tuoi numeri reali",
};

export const WHY = {
  eyebrow: "Perché Dentro il Calice",
  title: "Tecnologia agnostica.\nCompetenza verticale.",
  body: "Non vendiamo un software specifico. Analizziamo il processo e utilizziamo gli strumenti più adatti all'obiettivo della cantina. Il valore non è possedere l'ennesima piattaforma: è fare dialogare correttamente CRM, email, database, booking, ecommerce, commerciale, marketing, export e knowledge aziendale.",
  columns: [
    { title: "Wine Knowledge", body: "Conoscenza concreta della filiera e del linguaggio del vino." },
    { title: "AI & Automation", body: "Applicazioni pratiche di AI, workflow e integrazione dati." },
    { title: "Business Measurement", body: "Baseline, KPI e verifica dei risultati." },
  ],
};

export const DONT = {
  eyebrow: "Cosa non facciamo",
  title: "Anche dire no fa parte del metodo.",
  notPromise: {
    heading: "Non promettiamo",
    items: [
      "Aumento garantito del fatturato",
      "Nuovi importatori garantiti",
      "Automazione totale dell'azienda",
      "Sostituzione di commerciali, export o marketing manager",
      "Consulenza legale automatizzata",
      "Decisioni enologiche autonome",
    ],
  },
  notBuild: {
    heading: "Non sviluppiamo inizialmente",
    items: [
      "ERP proprietari",
      "Precision farming",
      "Sensoristica di vigneto",
      "Sistemi fitosanitari",
      "Software agronomico",
    ],
  },
};

export const CASES = {
  eyebrow: "Casi misurati",
  title: "Case study in costruzione.",
  body: "I primi progetti Dentro il Calice AI Winery vengono documentati attraverso baseline, KPI e risultati verificabili. Non utilizziamo falsi testimonial.",
  placeholder: "[ PLACEHOLDER — case study reali in preparazione ]",
  cta: "Vuoi essere una delle prime cantine lighthouse?",
};

export const LIGHTHOUSE = {
  eyebrow: "Programma pilota",
  title: "Cerchiamo le prime cantine lighthouse.",
  body: "Stiamo selezionando un numero limitato di aziende con processi commerciali misurabili sulle quali implementare e documentare i primi sistemi Dentro il Calice AI Winery.",
  requirements: [
    "Disponibilità di dati digitali",
    "Referente interno",
    "Obiettivo commerciale definito",
    "Disponibilità alla misurazione dei KPI",
    "Disponibilità a lavorare sui processi",
  ],
  cta: "Candida la tua cantina",
};

export const FAQ = {
  eyebrow: "FAQ",
  title: "Domande frequenti.",
  items: [
    { q: "Cos'è Dentro il Calice AI Winery?", a: "Una società verticale che applica AI, automazioni e dati ai processi commerciali e operativi delle aziende vitivinicole. Costruiamo sistemi applicati a problemi reali della cantina, non vendiamo tecnologia fine a se stessa." },
    { q: "È un software?", a: "No. Non vendiamo una piattaforma. Analizziamo il processo e configuriamo gli strumenti più adatti all'obiettivo, facendoli dialogare tra loro." },
    { q: "Devo cambiare il mio CRM?", a: "Non necessariamente. Partiamo da ciò che già usi e interveniamo dove serve. L'obiettivo è mettere ordine, non aggiungere strumenti." },
    { q: "Utilizzate ChatGPT?", a: "Utilizziamo diversi strumenti di AI in modo agnostico, con policy, controllo umano e governance. Non vendiamo \"ChatGPT alla cantina\"." },
    { q: "Potete collegarvi ai software che già utilizziamo?", a: "Sì, quando le integrazioni sono disponibili. Analizziamo il tuo stack durante l'audit e definiamo le connessioni fattibili." },
    { q: "L'AI sostituirà il personale?", a: "No. Eliminiamo attività ripetitive e informazioni disperse per liberare tempo alle persone. Il controllo resta umano." },
    { q: "Quanto dura un progetto?", a: "L'AI Wine Audit dura 7–10 giorni lavorativi. L'implementazione dipende dai casi d'uso prioritizzati e viene definita nella roadmap a 90 giorni." },
    { q: "Da dove si comincia?", a: "Dalla diagnosi gratuita e, successivamente, dall'AI Wine Audit: un caso d'uso, un KPI, un risultato misurabile." },
    { q: "Perché l'AI Wine Audit è a pagamento?", a: "Perché produce un output decisionale reale: mappatura processi, casi d'uso, matrice impatto/fattibilità, analisi rischi, roadmap e stima economica." },
    { q: "Come vengono gestiti i dati della cantina?", a: "Con criteri di riservatezza e governance definiti insieme. I dettagli tecnici e contrattuali vengono formalizzati prima dell'avvio del progetto. [Da verificare legalmente prima della pubblicazione]" },
    { q: "Possiamo lavorare sull'export?", a: "Sì. Con AI Export & Scale aumentiamo capacità, velocità e disciplina del processo commerciale. Non promettiamo ordini o distributori garantiti." },
    { q: "Potete garantire un incremento delle vendite?", a: "No. Non promettiamo risultati garantiti. Definiamo i KPI prima dell'implementazione e misuriamo il prima/dopo." },
    { q: "Lavorate anche con consorzi e cooperative?", a: "Sì, quando esistono processi commerciali misurabili e un referente interno. Parliamone in diagnosi." },
  ],
};

export const LEAD = {
  eyebrow: "Diagnosi gratuita",
  title: "Prima di parlare di AI,\nparliamo della tua cantina.",
  subtitle: "20–30 minuti per capire dove esistono inefficienze, dati inutilizzati o processi migliorabili.",
  channels: ["Vendita diretta", "Enoturismo", "Ecommerce", "Ho.Re.Ca.", "Export", "GDO"],
  revenueBands: ["< €1M", "€1M – €5M", "€5M – €20M", "> €20M", "Preferisco non indicare"],
  cta: "Richiedi la diagnosi",
  privacy: "Ho letto e accetto la Privacy Policy e autorizzo il trattamento dei dati per essere ricontattato.",
};

export const FOOTER = {
  tagline: "Trasformiamo dati, processi e relazioni commerciali in sistemi misurabili per il settore vitivinicolo.",
  legal: [
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Cookie Policy", href: "/cookie" },
    { label: "Contatti", href: "#lead" },
  ],
  social: [
    { label: "LinkedIn", href: "#" },
    { label: "Instagram", href: "#" },
    { label: "YouTube", href: "#" },
  ],
  company: {
    ragioneSociale: "Stefano Cremonese",
    piva: "P.IVA 04780750230",
    indirizzo: "Piazza J.F. Kennedy 2, 37060 Castel d'Azzano (VR), Italia",
    email: "agenzia@dentroilcalice.it",
    telefono: "+39 348 261 8512",
    pec: "stefcrem@pec.com",
  },
};


// ============================================================
// CONTATTO DIRETTO (thank-you page)
// ============================================================
export const CONTACT = {
  email: "agenzia@dentroilcalice.it",
  phone: "+39 348 261 8512",
};

// ============================================================
// PAGINE SERVIZI DEDICATE
// ============================================================
export const SERVICE_DETAILS = {
  "/ai-wine-audit": {
    slug: "ai-wine-audit",
    eyebrow: "Servizio · Punto di partenza",
    name: "AI Wine Audit",
    price: "€1.250",
    priceNote: "una tantum",
    duration: "7–10 giorni lavorativi",
    tagline: "Prima di implementare qualsiasi cosa, capiamo dove la tua cantina perde tempo, dati o opportunità.",
    image: IMAGES.businessMeeting,
    intro:
      "L'AI Wine Audit è il primo passo concreto. Non parte dalla tecnologia, ma dai tuoi processi commerciali e operativi. In pochi giorni otteniamo una fotografia chiara di ciò che oggi funziona, di ciò che rallenta e dei casi d'uso a maggior impatto per la tua realtà.",
    forWho: "Per cantine che vogliono decidere con dati alla mano, prima di investire in workflow o automazioni.",
    sections: [
      {
        h: "Come si svolge",
        items: [
          "2 workshop con titolare e referenti dei processi",
          "Mappatura dei processi commerciali e operativi",
          "Analisi della data readiness (CRM, ecommerce, mailing, gestionale)",
          "Individuazione di 8–12 possibili casi d'uso",
          "Matrice impatto / fattibilità per prioritizzare",
          "Analisi dei rischi e dei vincoli",
          "Roadmap operativa a 90 giorni",
          "Stima economica del progetto",
        ],
      },
    ],
    output: "Report decisionale + backlog prioritizzato + architettura proposta. Un documento con cui decidere, non una demo commerciale.",
    note: null,
    ctaLabel: "Richiedi l'AI Wine Audit",
  },
  "/revenue-starter": {
    slug: "revenue-starter",
    eyebrow: "Servizio · Setup + canone",
    name: "AI Revenue Starter",
    price: "€4.900",
    priceNote: "setup + €390 / mese",
    duration: null,
    tagline: "Migliora CRM e follow-up senza avviare un progetto enterprise.",
    image: IMAGES.tastingRoom,
    intro:
      "Un sistema essenziale ma completo per non perdere più lead e per riattivare i clienti che non ricomprano. Ideale come primo impianto di automazione commerciale, con dashboard e formazione incluse.",
    forWho: "Per cantine che vogliono ordine nei dati e follow-up affidabili, partendo da ciò che già usano.",
    sections: [
      {
        h: "Cosa include",
        items: [
          "Data hygiene di base sul database clienti",
          "3 workflow operativi",
          "Lead capture e lead qualification",
          "Follow-up automatico",
          "Reactivation clienti",
          "Assistente interno",
          "Dashboard KPI",
          "Formazione del team",
        ],
      },
    ],
    output: null,
    note: "I KPI vengono definiti prima dell'attivazione. Nessuna percentuale di miglioramento promessa a priori.",
    ctaLabel: "Parliamo di Revenue Starter",
  },
  "/growth-system": {
    slug: "growth-system",
    eyebrow: "Servizio · Setup + canone",
    name: "AI Growth System",
    price: "€8.900",
    priceNote: "setup + €790 / mese",
    duration: null,
    tagline: "Per cantine con team commerciale, marketing, DTC o più canali.",
    image: IMAGES.barrelCellar,
    intro:
      "Un sistema più esteso, pensato per chi ha già più canali e un team che deve lavorare in modo coordinato. Copre vendite, contenuti, segmentazione e reporting, con ottimizzazione continua.",
    forWho: "Per cantine strutturate con vendita diretta, enoturismo, ecommerce e attività di marketing.",
    sections: [
      {
        h: "Cosa include",
        items: [
          "6–8 workflow",
          "Sales copilot",
          "Knowledge base aziendale",
          "Segmentazione e reactivation",
          "Content operations",
          "Reporting e dashboard",
          "Integrazioni standard",
          "Formazione, monitoraggio e ottimizzazione continua",
        ],
      },
    ],
    output: null,
    note: "Ogni caso d'uso è collegato a un KPI misurabile, verificato prima/dopo.",
    ctaLabel: "Parliamo di Growth System",
  },
  "/export-scale": {
    slug: "export-scale",
    eyebrow: "Servizio · Setup + canone",
    name: "AI Export & Scale",
    price: "€14.900",
    priceNote: "setup + €1.490 / mese",
    duration: null,
    tagline: "Per aziende strutturate con export attivo o obiettivi di internazionalizzazione.",
    image: IMAGES.vineyardVilla,
    intro:
      "Il sistema più completo, dedicato al processo commerciale export. Aumenta capacità, velocità e disciplina nella ricerca, qualificazione e gestione dei buyer, con materiali multilingua e governance.",
    forWho: "Per aziende con export attivo o in fase di apertura di nuovi mercati.",
    sections: [
      {
        h: "Cosa include",
        items: [
          "8–10+ workflow",
          "Market research assistito",
          "Account scoring",
          "Pipeline export",
          "Materiali multilingua",
          "Follow-up e knowledge base",
          "Dashboard e governance",
          "Integrazioni e quality control",
          "Review mensile",
        ],
      },
    ],
    output: null,
    note: "Importante: non promettiamo ordini, distributori o incremento export garantito. Il servizio aumenta la capacità, la velocità e la disciplina del processo commerciale.",
    ctaLabel: "Parliamo del tuo export",
  },
};
